export default __webpack_public_path__ + "static/media/participantCertificate.c698b545.png";